import { Box, IconButton, Tooltip } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";

export const LogoutButton = () => {

  return (
    <Box>
      <Tooltip title="Logout">
        <IconButton
          onClick={() => { }}
          size="small"
          sx={{
            color: "text.secondary",
            "&:hover": {
              color: "primary.main",
            },
          }}
        >
          <LogoutIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
